import Model from "../../../shared/model/GameModel.js";
import IntroController from "./IntroController.js";
import GameController from "./GameController.js";
import ResultController from "./ResultController.js";
import SVGController from "../../../shared/js/utils/SVG.js";
import Ereaser from "../../../shared/js/utils/Eraser.js";

document.addEventListener("alpine:init", () => {
	// Load configuration from global window object
	const config = window.nngLuckyPigConfig;

	// Returns a usable value, or the fallback when the raw value is missing,
	// empty, or an unresolved server-side template placeholder (e.g. "${WinAmount}").
	// These win-related properties are only filled by the backend after the ticket
	// has been redeemed (on the reload), so on the first load they can arrive empty
	// or as raw placeholders.
	const orFallback = (value, fallback) => {
		if (value === undefined || value === null) return fallback;
		const str = String(value).trim();
		if (str === "" || /^\$\{.*\}$/.test(str)) return fallback;
		return value;
	};

	// Initialize game model with predefined properties
	const nngGameModel = new Model({
		winType: orFallback(config.winType, "nowin"),
		isWinner: config.isWinner === true || config.isWinner === "true",
		pattern: config.pattern,
		ticketURL: orFallback(config.ticketURL, "/"),
		scratched: config.scratched === true || config.scratched === "true",
		winAmount: orFallback(config.winAmount, "0.00"),
		price: orFallback(config.price, "0.00"),
		prizeLevelNo: orFallback(config.prizeLevelNo, "0"),
		prizeLevelName: orFallback(config.prizeLevelName, ""),
		freeTicketCount: orFallback(config.freeTicketCount, "0"),
	});

	// Create an Alpine.js store to resolve intern routes (paths)
	Alpine.store("resolver", {
		page: {
			controller: { value: null }, // Holds the active controller instance
			path: { value: "" }, // Stores the current page path
		},

		resolve(path, id = 0) {
			// Handle different game states
			if (path == "intro") {
				this.page.controller.value = new IntroController({
					text: "Glueckschwein",
				});
			}

			if (path == "game") {
				this.page.controller.value = new GameController({
					nngGameModel,
				});

				// Wait for the SVG element to be available before initializing
				const observer = new MutationObserver(() => {
					const SVG = document.querySelector("#nng-luckypig-svg");

					if (SVG) {
						this.page.controller.value.initSVG(
							new SVGController(SVG),
							new Ereaser(SVG),
						);
						observer.disconnect(); // Stop observing once initialized
					}
				});
				const module = document.querySelector("#nng-module-luckypig");
				observer.observe(module, { childList: true, subtree: true });
			}

			if (path == "result") {
				this.page.controller.value = new ResultController({
					nngGameModel: nngGameModel,
					winAmount: nngGameModel.winAmount,
				});
			}

			this.page.path.value = path; // Update current path
		},

		isLoaded() {
			return this.page.controller.value; // Check if a controller is active
		},
	});

	// Determine the initial game state (show result if played, otherwise intro)
	if (nngGameModel.isGamePlayed) {
		Alpine.store("resolver").resolve("result");
	} else {
		Alpine.store("resolver").resolve("intro");
	}
});
